<virtual-scroller #scroll [items]="results" class="gallery" [stripedTable]="true" bufferAmount="20">
	<table class="gallery__table">
		<tbody #container>
      <!-- Model -->
      <tr
        *ngFor="let result of scroll.viewPortItems"
        class="gallery__row" (click)="handleSelect(result)"
        [ngClass]="{'gallery__row--checked': isChecked(result.id)}">
        
				<td class="gallery__cell gallery__cell--model">
          <div class="gallery__model">
            <div class="gallery__image-container">
              <div class="gallery__image"
                *ngIf="result.thumbnail_url"
                [ngStyle]="{'background-image': 'url(' + result.thumbnail_url + ')'}">
              </div>
            </div>
    
            <div class="gallery__label">{{result.title}}</div>
          </div>
        </td>

        <!-- Tags -->
				<td class="gallery__cell gallery__cell--tags hide-md">
          <span class="text-10 text-uppercase text-medium text-dim">
            <ng-container *ngTemplateOutlet="galleryTagsTemplate; context: { $implicit: result }"></ng-container>
          </span>
        </td>
        
        <!-- Author -->
        <td class="gallery__cell gallery__cell--author hide-md">
          {{ result.author_first_name || result.author }}
        </td>
        
        <td class="gallery__cell gallery__cell--updated hide-md">
          <span *ngIf="result.editor?.name">
              {{ result.last_editor_first_name || result.last_editor }} on 
          </span>
          
          {{ (result.update_date_time || result.create_date_time ) | date:'shortDate' }}
        </td>

        <td class="gallery__cell gallery__cell--checkbox hide-md" *ngIf="checkable" appEventFence>
          <div class="gallery__checkbox hide-sm" *ngIf="checkable" appEventFence>
            <mat-checkbox [value]="result.id" (change)="handleCheckedChange($event)" [checked]="isChecked(result.id)"></mat-checkbox>
          </div>
        </td>

        <td class="gallery__cell gallery__cell--actions hide-md" *ngIf="showActions" appEventFence>
          <div class="gallery__actions">
            <ng-container *ngTemplateOutlet="galleryActionsTemplate; context: { $implicit: result }"></ng-container>
          </div>
        </td>
			</tr>
    </tbody>
    
    <!-- thead must come after tbody in order for the checkboxes to render below the header on scroll
    This is due to the header using transform(), and the checkboxes using position relative, which cause them to render over the header -->
    <thead #header>
      <th class="gallery__cell gallery__cell--header">Model</th>
      <th class="gallery__cell gallery__cell--header hide-md">Tags</th>
      <th class="gallery__cell gallery__cell--header hide-md">Author</th>
      <th class="gallery__cell gallery__cell--header hide-md">Updated</th>
      <td class="gallery__cell gallery__cell--header hide-md" *ngIf="checkable"></td>
      <th class="gallery__cell gallery__cell--header hide-md" *ngIf="showActions"></th>
    </thead>
	</table>
</virtual-scroller>
